module.exports = __webpack_public_path__ + "f28744d0215954c9282ddca70cb94a3e.png";